export default __webpack_public_path__ + "static/media/Gauntlets of Clarity.b7d70d55.jpg";